import { Component, OnInit, ViewChild } from '@angular/core';
import { stagger60ms } from '../../../@vex/animations/stagger.animation';
import { fadeInUp400ms } from '../../../@vex/animations/fade-in-up.animation';
import { UserStore } from '@stores/user.store';
import { ApiService } from '@services/api.service';
import { User } from '@entities/user.entity';
import { AppMessageService } from '@services/message.service';

@Component({
	selector: 'app-dashboard',
	templateUrl: 'dashboard.component.html',
	styleUrls: ['dashboard.component.scss'],
	animations: [stagger60ms, fadeInUp400ms],
})
export class DashboardComponent implements OnInit {
	currentUser: User;
	dashboardMarkDownFromServer = '';
	user = {} as User;
	editMode = false;
	isNewFile = true;

	processSteps = [
		{
			title: 'Jira',
			subtitle: 'Plan & Track',
			colorXXX: '#0963DD',
			color: '#2A6992',
			icon: '/assets/logos/jira.svg',
			link: 'https://it-objects.atlassian.net',
		},
		{
			title: 'Teams',
			subtitle: 'Document',
			colorXXX: '#7B83EB',
			color: '#71A1BF',
			icon: '/assets/logos/teams.svg',
			link: 'https://teams.microsoft.com',
		},
		{
			title: 'GitLab',
			subtitle: 'Develop',
			colorXXX: '#F96424',
			color: '#BCE2F0',
			icon: '/assets/logos/gitlab.svg',
			link: 'https://gitlab.it-objects.de',
		},
		{
			title: 'DevOps',
			subtitle: 'Build & Deploy',
			colorXXX: '#C63316',
			color: '#F08019',
			icon: '/assets/logos/gitlab.svg',
			link: 'https://gitlab.it-objects.de',
		},
		{
			title: 'Robot',
			subtitle: 'Quality',
			colorXXX: '#8d489b',
			color: '#FBBA3D',
			icon: '/assets/logos/robotframework.png',
			link: 'https://robotframework.org',
		},
		{
			title: 'Nexus',
			subtitle: 'Archive Repos',
			colorXXX: '#29B473',
			color: '#71A1BF',
			icon: '/assets/logos/nexus.svg',
			link: 'https://de.sonatype.com/nexus/repository-oss',
		},
	];

	constructor(private userStore: UserStore, private apiService: ApiService, private appMessageService: AppMessageService) {}

	async ngOnInit() {
		this.user = await this.userStore.getUser();
		const result = await this.apiService.get('files?name=dashboardContent');
		if (result && result.content) {
			this.isNewFile = false;
			this.dashboardMarkDownFromServer = result.content;
		}
	}

	async save() {
		try {
			this.isNewFile
				? await this.apiService.post('files', { name: 'dashboardContent', content: this.dashboardMarkDownFromServer })
				: await this.apiService.put('files', { name: 'dashboardContent', content: this.dashboardMarkDownFromServer });
			this.appMessageService.showToastSuccess('Stored');
			this.editMode = false;
		} catch (e) {
			console.error(e);
			this.appMessageService.showToastError('Error');
		}
	}

	openLink(link: string) {
		window.open(link, '_blank');
	}
}
